import React from 'react'

import { useTranslation } from 'react-i18next'

import { ErrorView } from '@/Components/error/ErrorView'

export const SearchPageError: React.FC = () => {
  const { t } = useTranslation()

  const ERROR_VIEW_PROPS = {
    headline: t('search.error.title'),
    text: t('search.error.subtitle'),
    image: <div className="spaceman" />,
  }
  return <ErrorView {...ERROR_VIEW_PROPS} />
}
